export default {
  medications: {
    label: 'Лекарства',
    filterTitle: 'Фильтр по статусу',
    search: 'Искать лекарства',
    status: {
      draft: 'Проект',
      active: 'Активный',
      onHold: 'На удерживании',
      cancelled: 'Отменено',
      completed: 'Завершено',
      enteredInError: 'Введено по ошибке',
      stopped: 'Остановлен',
      unknown: 'Неизвестно',
    },
    intent: {
      proposal: 'Предложение',
      plan: 'Строить планы',
      order: 'порядок',
      originalOrder: 'Исходный заказ',
      reflexOrder: 'Рефлекторный заказ',
      fillerOrder: 'Заказ заполнителя',
      instanceOrder: 'Порядок экземпляров',
      option: 'Вариант',
    },
    priority: {
      routine: 'Рутина',
      urgent: 'Срочно',
      asap: 'Как можно скорее',
      stat: 'Стат',
    },
    filter: {
      all: 'Все статусы',
    },
    requests: {
      label: 'Запросы на лекарства',
      new: 'Запросить лекарство',
      view: 'Просмотреть лекарство',
      cancel: 'Отменить лечение',
      complete: 'Полное лекарство',
      error: {
        unableToRequest: 'Невозможно создать запрос на лекарство.',
        unableToComplete: 'Невозможно выполнить запрос на лекарство.',
        quantityRequired: 'Требуется количество.',
        unitRequired: 'Требуется блок.',
      },
    },
    medication: {
      medication: 'Медикамент',
      for: 'За',
      status: 'Статус',
      intent: 'Намерение',
      priority: 'Приоритет',
      notes: 'Заметки',
      quantity: 'Количество',
      quantityValue: 'Ценность',
      quantityUnit: 'Единица измерения',
      requestedOn: 'Запрошено',
      requestedBy: 'Запрошенный',
      completedOn: 'Завершено',
      canceledOn: 'Отменено',
      patient: 'Пациент',
    },
  },
}
